import { useState } from "react";
import { Link } from "react-router-dom";
import { CharteSignatureForm } from "@/components/home/CharteSignatureForm";

const TikTok = () => {
  const [showForm, setShowForm] = useState(false);

  return (
    <div 
      className="min-h-screen flex items-center justify-center p-4 relative"
      style={{
        backgroundImage: 'url(/lovable-uploads/signature-background.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="absolute inset-0 bg-yellow-400/50 backdrop-blur-md"></div>
      <div className="w-full max-w-md relative z-10">
        {!showForm ? (
          <div className="space-y-6 animate-fade-in">
            <h1 className="text-4xl font-bold text-white mb-4 text-shadow-lg">
              Signez la Charte du citoyen français
            </h1>
            <p className="text-lg text-white/90 leading-relaxed text-shadow-md">
              Recevrez gratuitement votre charte personnalisée par email
            </p>
            <button
              onClick={() => setShowForm(true)}
              className="w-full bg-blue-500 hover:bg-blue-600 text-white text-xl font-semibold py-4 px-6 rounded-xl transition-all duration-300 transform hover:scale-105 active:scale-95 shadow-lg"
            >
              Je signe la charte
            </button>
            
            <div className="space-y-3 text-white/90 text-shadow-md">
              <div className="flex items-start gap-2">
                <span className="text-green-400 font-bold text-lg">✅</span>
                <span className="text-base">Déjà 1 000+ soutiens</span>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-green-400 font-bold text-lg">✅</span>
                <a 
                  href="/Charte_des_droits_et_devoirs_du_citoyen_francais-juin-2020.pdf" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-base hover:underline"
                >
                  Charte officielle
                </a>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-green-400 font-bold text-lg">✅</span>
                <Link 
                  to="/politique-confidentialite" 
                  className="text-base hover:underline"
                >
                  Données protégées
                </Link>
              </div>
            </div>
            
            <Link 
              to="/" 
              className="block text-center text-white/80 hover:text-white text-sm font-medium transition-colors text-shadow-md"
            >
              Accueil
            </Link>
          </div>
        ) : (
          <div className="bg-white rounded-2xl p-6 shadow-2xl animate-fade-in">
            <button
              onClick={() => setShowForm(false)}
              className="mb-4 text-gray-700 hover:text-gray-900 flex items-center gap-2 font-medium"
            >
              ← Retour
            </button>
            <CharteSignatureForm onSuccess={() => {
              // Success handled by the form component
            }} />
          </div>
        )}
      </div>
    </div>
  );
};

export default TikTok;
